<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="colorgrp_id" [ttModel]="menu.colorgrp_id" ttReadonly></tt-input>
        <tt-input ttLabel="colorgrp_name" [ttModel]="menu.colorgrp_name" [ttButtons]="colourGroupNameButtons" ttReadonly></tt-input>
        <tt-input ttLabel="sortorder" [ttModel]="menu.sortorder" ttReadonly></tt-input>
        <tt-button-goto [ttText]="'colorgrpmenu_edit'" [ttGoto]="'colorgrp'" [ttGotoParms]="{ colorgrp_id: menu.colorgrp_id }"></tt-button-goto>
        <tt-button ttText="colorgrpmenu_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
